import i18n from '../../../i18n';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react";
import AppBreadcrumb from "../../Shared/AppBreadcrumb";
import FecthingSpinner from "../../Shared/FecthingSpinner";
import {
  fetchPaymentMethods,
  deletePaymentMethod,
} from "../../../api/paymentMethods";
import MyOpinionLogo from "../../../assets/images/MyOpinion_Logo_Head.png";
import { Link } from "react-router-dom";

const PaymentMethods = () => {
    const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(true);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const fetchData = async () => {
    try {
      setFetching(true);
      const response = await fetchPaymentMethods();

      if (response?.success) {
        const methods = response.data?.map((item) => {
          let countries = [];
          if (Array.isArray(item?.countries)) {
            countries = item.countries.filter(
              (c) => c && (c.code != null || c.id != null)
            );
          } else if (Array.isArray(item?.country_ids)) {
            countries = item.country_ids.map((id) => ({ id }));
          }
          return { ...item, countries };
        });

        setData(methods);
      }
    } catch (error) {
      console.error("Erreur chargement méthodes:", error?.response?.data || error);
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const confirmDeleteMethod = async () => {
    if (!deleteTarget?.method_id) return;
    setDeleteLoading(true);
    try {
      await deletePaymentMethod(deleteTarget.method_id);
      setDeleteTarget(null);
      await fetchData();
    } catch (e) {
      alert(e?.response?.data?.message || i18n.t("Suppression impossible."));
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <AppBreadcrumb title={t("Liste de méthode de paiement")} />
      {fetching ? (
        <FecthingSpinner />
      ) : (
        <div className="card">
          <div className="table-responsive">
            <table className="table table-hover table-custom spacing8">
              <thead>
                <tr>
                  <th>{t("Logo")}</th>
                  <th>{t("Méthode")}</th>
                  <th>{t("Référence")}</th>
                  <th>{t("Pays")}</th>
                  <th>{t("Status")}</th>
                  <th className="text-right">
                    <span className="sr-only">{t("Actions")}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item) => (
                  <tr key={item?.method_id}>
                    <td className="w60">
                      <Link
                        to={`/payment-methods/${item.method_id}`}
                        className="text-dark"
                      >
                        <img
                          src={item?.method_logo || MyOpinionLogo}
                          alt=""
                          className="w35 rounded-full"
                          style={{
                            objectFit: "cover",
                            borderRadius: 500,
                            border: "1px solid #c0c0c0",
                          }}
                        />
                      </Link>
                    </td>
                    <td style={{ fontWeight: "500" }}>
                      <Link
                        to={`/payment-methods/${item.method_id}`}
                        className="text-dark"
                      >
                        {item?.method_name}
                      </Link>
                    </td>
                    <td style={{ fontWeight: "500" }}>
                      <Link
                        to={`/payment-methods/${item.method_id}`}
                        className="text-dark"
                      >
                        {item?.method_tag}
                      </Link>
                    </td>
                    <td style={{ fontWeight: "500" }}>
                      <Link
                        to={`/payment-methods/${item.method_id}`}
                        className="text-secondary"
                      >
                        {item?.countries?.length || 0} pays
                      </Link>
                    </td>
                    <td>
                      <span
                        className={`badge ${
                          item?.method_state === "available"
                            ? "badge-success"
                            : "badge-danger"
                        }`}
                      >
                        {item?.method_state}
                      </span>
                    </td>
                    <td className="text-right">
                      <div
                        className="d-inline-flex justify-content-end"
                        style={{ gap: "6px" }}
                      >
                        <Link
                          to={`/payment-methods/${item.method_id}`}
                          className="btn btn-sm btn-outline-primary d-inline-flex align-items-center justify-content-center p-0"
                          style={{ width: 34, height: 34, borderRadius: "8px" }}
                          title={t("Configurer / frais")}
                          aria-label={i18n.t("Configurer la méthode")}
                        >
                          <i className="icon-settings" aria-hidden />
                        </Link>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center p-0"
                          style={{ width: 34, height: 34, borderRadius: "8px" }}
                          title={t("Supprimer")}
                          aria-label={i18n.t("Supprimer la méthode")}
                          onClick={() => setDeleteTarget(item)}
                        >
                          <i className="icon-trash" aria-hidden />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {deleteTarget && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ background: "rgba(15, 23, 42, 0.45)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div
              className="modal-content border-0 shadow-lg"
              style={{ borderRadius: "14px", overflow: "hidden" }}
            >
              <div
                className="modal-header border-0 text-white"
                style={{
                  background:
                    "linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%)",
                }}
              >
                <h5 className="modal-title mb-0">{t("Supprimer la méthode ?")}</h5>
                <button
                  type="button"
                  className="close text-white"
                  onClick={() => !deleteLoading && setDeleteTarget(null)}
                  disabled={deleteLoading}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-secondary">
                <p className="mb-0">
                  <strong>{deleteTarget.method_name}</strong> (
                  <code>{deleteTarget.method_tag}</code>) — impossible si des
                  portefeuilles utilisent encore cette méthode.
                </p>
              </div>
              <div className="modal-footer border-0 bg-light">
                <button
                  type="button"
                  className="btn btn-light border"
                  style={{ borderRadius: "8px" }}
                  onClick={() => setDeleteTarget(null)}
                  disabled={deleteLoading}
                >
                  Annuler
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ borderRadius: "8px" }}
                  onClick={confirmDeleteMethod}
                  disabled={deleteLoading}
                >
                  {deleteLoading ? "Suppression…" : i18n.t("Supprimer")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethods;
